export const RECEIVE_QUESTIONS = "RECEIVE_QUESTIONS";
export const ADD_ANSWER_TO_QUESTION = "ADD_ANSWER_TO_QUESTION";
export const RECEIVE_USERS = "RECEIVE_USERS";
export const ADD_ANSWER_TO_USER = "ADD_ANSWER_TO_USER";
export const ADD_NEW_QUESTION = "ADD_NEW_QUESTION";
export const ADD_NEW_QUESTION_TO_USER = "ADD_NEW_QUESTION_TO_USER";
